export default __webpack_public_path__ + "static/media/sn.db3a85d1.svg";